import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { ADELPHI_SPIRIT_REDUCTIONS_DEFAULT_STATE } from './constants';

const completedState = completeState(ADELPHI_SPIRIT_REDUCTIONS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [
    actions.CREATE_ADELPHI_SPIRIT_REDUCTION,
    actions.GET_ALL_ADELPHI_SPIRIT_REDUCTIONS,
    actions.UPDATE_ADELPHI_SPIRIT_REDUCTION_BY_ID,
    actions.GET_ADELPHI_SPIRIT_REDUCTION_BY_ID
  ],
  override: { [actions.SET_CURRENT_ADELPHI_SPIRIT_REDUCTION]: onReadValue() }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
